import $ from 'jquery';
import React from 'react';
import Chart from "react-google-charts";
import {UserToken,getUserObjData,getAccessFunctions} from '../function_lib/userToken';
import {CallMapMethod, GetDateDifferecec,CallMapMethod_CBack,_getInitParam} from '../function_lib/common_lib';
import Header from './header';
import Footer from './footer';
import LogoImg from '../assets/images/logo_p_small.png';
import defaultPic from '../assets/images/9.png';

import Upcoming_Events from '../components/upcoming_events';
import Emp_On_Leave from '../components/emp_on_leave';
import Broadcast from '../components/broadcast';
import Mobile_Widgets from '../components/mobile_widgets';
import {LineChart,BarChart,Comparison_BarChart,Top_Overall_BarChart} from '../components/graphical_reports';
import {Comp_Map_Marker} from '../components/comp_map_marker';
import castrol1 from '../assets/images/sm_castrol1.jpg';

import './dashboard_new.css';

//import UserManual from '../assets/Operational_Instructions.pdf';

let loginUser="";
let userObject="";
let companyName="";
let userType="";
let clsDashboardNew;

let _chkOrderCall=false;
let _chkAnalyticsCall=false;
let _chkCmsCall=false;
let _initSettings={};
class Graph_Analytics extends React.Component{
    forceUpdateHandler(){
        this.forceUpdate();
      };
    constructor(props){
        super(props);
        clsDashboardNew=this;
        _initSettings=_getInitParam();
        //alert(JSON.stringify(_initSettings.app_settings.settings.dashboard));
        _initSettings=_initSettings.app_settings.settings.dashboard;
        this.state={creditBalance:[],stStatePerformance:[],stLast15Days:[],
          stLast15DWorkShops:[],stTopPerfOverAll:[],stTillDateTo:[],stMachineCounts:[]
        ,stQlcList:[]};
        //this.state={no_entities:0,no_clients:0,no_vendors:0}
        this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
        userType="0";
        
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }

      let ret= getAccessFunctions();
      //alert(ret);
     
    }
    getCreditBalance(){
      var map=[];
      map.push({name:"curl_type",value:"getCreditBalance"});
      map.push({name:"res_func",value:"callBackrrr"});
      map.push({name:"local_token",value:userObject[0].app_user_id});
      //map.push({name:"acc_inf_id",value:userObject[0].app_user_id});
      
      map["res_func"]="callBackrrr";
      map["curl_type"]="getCreditBalance";
      CallMapMethod_CBack(clsDashboardNew,map,function(data,msg){
        //alert(data);
          if(data!=="0" && data!==""){
              let listData=JSON.parse(data);
              var strData="";
              clsDashboardNew.setState({creditBalance:listData},()=>{
                clsDashboardNew.forceUpdateHandler();
              })
            }
      });
}

getDashBoardPerfo(){
  var map=[];
  map.push({name:"curl_type",value:"getGraphAnalyticsRpt"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].id});
  map.push({name:"gb_token",value:userObject[0].app_user_id});
  //map.push({name:"acc_inf_id",value:userObject[0].app_user_id});
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="getGraphAnalyticsRpt";

  CallMapMethod_CBack(clsDashboardNew,map,function(data,msg){
    
    if(data!=="0" && data!==""){
      let jsData=JSON.parse(data);
      
      let jsLast15Days=[];
      for(let l=0;l<jsData["last_15_oil"].length;l++){
        jsLast15Days.push({primary:jsData["last_15_oil"][l]["date_group_v"],secondary:jsData["last_15_oil"][l]["oil_change"],link: '../regional_analysis?durex='+btoa(jsData["last_15_oil"][l]["date_group_v"])})
      }

      //last 15 days workshops
      let jsLast15WorkShops=[];
      for(let l=0;l<jsData["last_15_workshops"].length;l++){
        jsLast15WorkShops.push({primary:jsData["last_15_workshops"][l]["business_name"],secondary:jsData["last_15_workshops"][l]["oil_change"],link: '../workshops_performance/'+btoa(jsData["last_15_workshops"][l]["id"])+"?rf="+btoa("last_15")})
      }

      let jsTopOverAll=[];
      for(let l=0;l<jsData["top_overall"].length;l++){
        jsTopOverAll.push({primary:jsData["top_overall"][l]["business_name"],secondary:jsData["top_overall"][l]["oil_change"],link: '../workshops_performance/'+btoa(jsData["top_overall"][l]["id"])})
      }

      //alert(JSON.stringify(jsData["qlc_list"]));

      clsDashboardNew.setState({stStatePerformance:jsData["state_prof"],
        stLast15Days:jsLast15Days,stLast15DWorkShops:jsLast15WorkShops,
        stTopPerfOverAll:jsTopOverAll,
        stTillDateTo:jsData["today_yest_till_date"],
        stMachineCounts:jsData["machine_counts"],
        stQlcList:jsData["qlc_list"],
      });

    }
  })

}

      componentDidMount(){
        //this.getCreditBalance();
        this.getDashBoardPerfo();
        $("#divEmployee").show();
        this.forceUpdateHandler();
      }
   //Get no of Entities/Client/Vendos
     
   
     

    render(){
        return(<div className="wrapper">
            <Header/>
            {/* <Mobile_Widgets/> */}
            <div class="content" style={{"min-height":"150px"}}>
            <div class="container-fluid mt-4">
                   {/* new acta component */}
                   <div className="row">
                    <div className="col-md-12">
                      
                      <div className="row">



   {/* dau view */}
   {(_initSettings["dau"]==="yes" && 0===0)?<>
           <div className="col-md-4">
            <div className="card card-widget widget-user-2">
              <div className="widget-user-header bg-warning">
                <div className="widget-user-image">
                
                 <span className="info-box-icon text-red bg-info1 elevation-11"><i className="fa fa-cogs fa-3x white" aria-hidden="true"></i></span>
                  
                 
                </div>
                <h3 className="widget-user-username"></h3>
                <h5 className="widget-user-desc white">{"Oil Change All India"}</h5>
              </div>
              <div className="card-footer p-0">
                <ul className="nav flex-column">
                  {this.state.stMachineCounts.length>0?
                  <li className="nav-item">
                    <a href="../primary_records" className="nav-link">
                    Machines Deployed <span className="float-right badge bg-primary">{this.state.stMachineCounts[0]["count_machines"]}</span>
                    </a>
                  </li>:''}
                  {this.state.stTillDateTo.length>0?<>
                  <li className="nav-item">
                    <a href={"../regional_analysis?rf="+btoa("today")} className="nav-link">
                    Oil Changes Today (Live) <span className="float-right badge bg-primary">{this.state.stTillDateTo[0]["today_count"]}</span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href={"../regional_analysis?rf="+btoa("yesterday")} className="nav-link">
                    Oil Changes – Yesterday <span className="float-right badge bg-primary">{this.state.stTillDateTo[0]["yesterday_count"]}</span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href={"../regional_analysis?rf="+btoa("last_week")} className="nav-link">
                    Oil Changes – Last Week <span className="float-right badge bg-primary">{this.state.stTillDateTo[0]["last_week_count"]}</span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href={"../regional_analysis?rf="+btoa("last_month")} className="nav-link">
                    Oil Changes – Last Month <span className="float-right badge bg-primary">{this.state.stTillDateTo[0]["last_month_count"]}</span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href={"../regional_analysis?rf="+btoa("till_date")} className="nav-link">
                    Total Oil Changes (Cumulative) <span className="float-right badge bg-primary">{this.state.stTillDateTo[0]["till_date_count"]}</span>
                    </a>
                  </li>
                  </>:''}
                </ul>
               
              </div>
            </div>
            {/* <img width={"100%"} src={castrol1}/> */}
          </div>
           </>
          :''}

{/*end dau view */}

                      {_initSettings["welcome_msg"]==="yes"?
                        <div className="col-md-12">
                          {/* Welcome of Fast RC Direct */}
                        </div>:''}
                    {/* user compoentnet  */}
            {/* component type */}
        {/* image thumb */}
  {_initSettings["dau"]==="yes"?<>
           {/* <div className="col-md-4">
            <div className="card card-widget widget-user-2">
             
              <img src={castrol1}/>
             
            </div>
          </div> */}
           </>
          :''}

{/*end of image*/}  
          {/* invoice order view */}
          {_initSettings["orders"]==="yes"?<>
             <div className="col-md-4">
            <div className="card card-widget widget-user-2">
              <div className="widget-user-header bg-warning">
                <div className="widget-user-image">
                
                 <span className="info-box-icon text-red bg-info1 elevation-11"><i className="fa fa-cubes fa-3x white" aria-hidden="true"></i></span>
                  
                 
                </div>
                <h3 className="widget-user-username"></h3>
                <h5 className="widget-user-desc white">{"Top Performing States This Month"}</h5>
              </div>
              <div className="card-footer p-0">
                <ul className="nav flex-column">
                  {this.state.stStatePerformance.map((item,index)=>{
                    return <li className="nav-item">
                    <a href={"../regional_analysis/"+btoa(item["state_id"])+"?rf="+btoa("this_month")} className="nav-link">
                    {item["state_name"]} <span className="float-right badge bg-primary">{item["oil_change"]}</span>
                    </a>
                  </li>
                  })}
                  
                  
                </ul>
              </div>
            </div>
          </div>
          
          </>
    :''}
          {/* end of invoice order view */}
            
         

  

{/* bar charts tesitng */}
{_initSettings["dau"]==="yes"?
           <div className="col-md-4">
            <div className="card card-widget widget-user-2">
              <div className="widget-user-header bg-warning">
                <div className="widget-user-image">
                
                 <span className="info-box-icon text-red bg-info1 elevation-11"><i className="fa fa-area-chart fa-3x white" aria-hidden="true"></i></span>
                  
                 
                </div>
                <h3 className="widget-user-username"></h3>
                <h5 className="widget-user-desc white">{"Last 15 Days Oil Changes"}</h5>
              </div>
              <div className="card-footer p-0">
              <LineChart lineData={this.state.stLast15Days}/>
              </div>
            </div>
          </div>
          :''}
{/* end of bar chart */}


{/* bar charts tesitng */}
{_initSettings["dau"]==="yes"?
           <div className="col-md-6">
            <div className="card card-widget widget-user-2">
              <div className="widget-user-header bg-warning white">
                <div className="widget-user-image">
                
                 <span className="info-box-icon text-red bg-info1 elevation-11"><i className="fa fa-cogs fa-3x white" aria-hidden="true"></i></span>
                  
                 
                </div>
                <h3 className="widget-user-username"></h3>
                <h5 className="widget-user-desc white">{"Top 10 Workshops (last 15 Days)"}</h5>
              </div>
              <div className="card-footer p-0">
              <BarChart lineData={this.state.stLast15DWorkShops}/>
              </div>
            </div>
          </div>
          :''}
{/* end of bar chart */}



{/* top Performers OverAll tesitng */}
{_initSettings["dau"]==="yes" && 1===0?
           <div className="col-md-6">
            <div className="card card-widget widget-user-2">
              <div className="widget-user-header bg-warning white">
                <div className="widget-user-image">
                
                 <span className="info-box-icon text-red bg-info1 elevation-11"><i className="fa fa-cogs fa-3x white" aria-hidden="true"></i></span>
                  
                 
                </div>
                <h3 className="widget-user-username"></h3>
                <h5 className="widget-user-desc white">{"Top 20 Performers(Overall)"}</h5>
              </div>
              <div className="card-footer p-0">
              <Top_Overall_BarChart lineData={this.state.stTopPerfOverAll}/>
              </div>
            </div>
          </div>
          :''}
{/* end of top performers */}


{/* top Comparison FY */}
{(_initSettings["dau"]==="yes" && 0===1)?
           <div className="col-md-6">
            <div className="card card-widget widget-user-2">
              <div className="widget-user-header bg-warning white">
                <div className="widget-user-image">
                
                 <span className="info-box-icon text-red bg-info1 elevation-11"><i className="fa fa-cogs fa-3x white" aria-hidden="true"></i></span>
                  
                 
                </div>
                <h3 className="widget-user-username"></h3>
                <h5 className="widget-user-desc white">{"Yearwise Performance (Overall)"}</h5>
              </div>
              <div className="card-footer p-0">
              <Comparison_BarChart />
              </div>
            </div>
          </div>
          :''}
{/* end of Comparison Overall */}

            {/* end of component tyep */}
</div>
</div>
{/* end of compaign */}
</div>
                {/* end of new acta component */}

{/* <!-- /.content --> */}
</div>
      </div> 
        <Footer/>
        
      </div>)
    }
}
export default Graph_Analytics